// ── AR Flow — NOVA INTERFACE (new-ui), etapa 1: casca visual ─────────────
// Só visual. Não lê nem grava Firebase, não chama API, não muda permissões.
// Liga/desliga por aparelho:  ?newui=1  liga   |   ?newui=0  desliga
// Com a chave desligada, o CRM fica exatamente como era antes.

const STORAGE_KEY = "arflow_new_ui";

// Lojas que já usam a cara nova por padrão: Rei dos Estofados,
// Rei dos Colchões, Mezzo Ponta Grossa e Mezzo Curitiba.
// Administração também usa a nova interface por padrão.
export const LOJAS_NOVA_INTERFACE = [1, 2, 3, 4];
const OPTOUT_KEY = "arflow_new_ui_off";

// ?newui=1 / ?newui=0 prevalecem e ficam gravados neste aparelho;
// sem escolha explícita, vale o padrão da loja do login.
export function isNewUiEnabled() {
  try {
    const param = new URLSearchParams(window.location.search).get("newui");
    if (param === "1") { localStorage.setItem(STORAGE_KEY, "1"); localStorage.removeItem(OPTOUT_KEY); }
    if (param === "0") { localStorage.removeItem(STORAGE_KEY); localStorage.setItem(OPTOUT_KEY, "1"); }
    if (localStorage.getItem(STORAGE_KEY) === "1") return true;
    if (localStorage.getItem(OPTOUT_KEY) === "1") return false;
    const usuario = JSON.parse(localStorage.getItem("arflow_user") || "null");
    if (!usuario || usuario.isDemo) return false;
    return usuario.role === "admin" || LOJAS_NOVA_INTERFACE.includes(Number(usuario.storeId));
  } catch {
    return false;
  }
}

// Neutros comuns (do desenho aprovado, Opção B)
const INK = "#1F1B16";
const INK_MUTED = "#6B5E4E";
const GREEN = "#1E6B4A";

// Mesmas chaves do THEMES atual (navy, accent, sand...), para que todas as
// telas que já usam T.* troquem de cor sem mexer nelas.
// Chaves nu* são só da barra lateral nova.
export const NEW_THEMES = {
  1: { // Rei dos Estofados
    navy:"#3B2A1E", navyMid:"#5A4332", navyLight:"#8B6423",
    accent:"#8B6423", accentLight:"#D4A954",
    sand:"#FBF8F3", sandDark:"#F4EBDD",
    positive:GREEN, gold:"#A87A2A",
    text:INK, muted:INK_MUTED, white:"#FFFFFF",
    headerGrad:"#FBF8F3", headerShadow:"inset 0 -1px 0 #E6DCCB",
    headerSubColor:"#6B5E4E", headerBtnBg:"rgba(59,42,30,0.06)", headerBtnColor:INK,
    headerTabInactive:"rgba(31,27,22,0.55)", tabActive:"#8B6423",
    icon:"👑", label:"Rei dos Estofados",
    storeButtonBg:"#3B2A1E", storeButtonText:"#F7F0E6",
    nuPage:"#FBF8F3", nuSide:"#3B2A1E", nuSideText:"#F7F0E6", nuSideMuted:"#D9C7B0",
    nuSideLine:"#5A4332", nuSideActive:"#8B6423", nuSideMark:"#D4A954", nuLine:"#E6DCCB",
  },
  2: { // Rei dos Colchões
    navy:"#16335F", navyMid:"#2A4B7C", navyLight:"#1F5FBF",
    accent:"#1F5FBF", accentLight:"#9CC0F0",
    sand:"#F7FAFE", sandDark:"#E8F0FB",
    positive:GREEN, gold:"#1F5FBF",
    text:INK, muted:"#5B6475", white:"#FFFFFF",
    headerGrad:"#FFFFFF", headerShadow:"inset 0 -1px 0 #DCE5F2",
    headerSubColor:"#5B6475", headerBtnBg:"rgba(22,51,95,0.06)", headerBtnColor:"#16335F",
    headerTabInactive:"rgba(22,51,95,0.55)", tabActive:"#1F5FBF",
    icon:"👑", label:"Rei dos Colchões",
    storeButtonBg:"#16335F", storeButtonText:"#FFFFFF",
    nuPage:"#FFFFFF", nuSide:"#16335F", nuSideText:"#FFFFFF", nuSideMuted:"#C7D5EA",
    nuSideLine:"#2A4B7C", nuSideActive:"#1F5FBF", nuSideMark:"#9CC0F0", nuLine:"#DCE5F2",
  },
  3: { // Mezzo Ponta Grossa
    navy:"#111111", navyMid:"#2E2E2E", navyLight:"#8B6A1F",
    accent:"#8B6A1F", accentLight:"#D4AF5A",
    sand:"#FAF8F3", sandDark:"#F5EFE2",
    positive:GREEN, gold:"#B8923A",
    text:INK, muted:"#5E5A52", white:"#FFFFFF",
    headerGrad:"#FFFFFF", headerShadow:"inset 0 -1px 0 #E6E0D2",
    headerSubColor:"#5E5A52", headerBtnBg:"rgba(17,17,17,0.05)", headerBtnColor:"#111111",
    headerTabInactive:"rgba(17,17,17,0.55)", tabActive:"#8B6A1F",
    icon:"⭐", label:"Mezzo Ponta Grossa",
    storeButtonBg:"#111111", storeButtonText:"#FFFFFF",
    nuPage:"#FFFFFF", nuSide:"#111111", nuSideText:"#FFFFFF", nuSideMuted:"#BDBDBD",
    nuSideLine:"#2E2E2E", nuSideActive:"#8B6A1F", nuSideMark:"#D4AF5A", nuLine:"#E6E0D2",
  },
  4: { // Mezzo Curitiba
    navy:"#FBF7EE", navyMid:"#F0E6CC", navyLight:"#8B6A1F",
    accent:"#8B6A1F", accentLight:"#D4AF5A",
    sand:"#FFFDF8", sandDark:"#F7F0E0",
    positive:GREEN, gold:"#8B6A1F",
    text:INK, muted:"#6B5A36", white:"#FFFFFF",
    headerGrad:"#FFFFFF", headerShadow:"inset 0 -1px 0 #EFE6D2",
    headerSubColor:"#6B5A36", headerBtnBg:"rgba(46,36,16,0.06)", headerBtnColor:"#2E2410",
    headerTabInactive:"rgba(46,36,16,0.55)", tabActive:"#8B6A1F",
    icon:"✨", label:"Mezzo Curitiba",
    storeButtonBg:"#FFFFFF", storeButtonText:"#2E2410",
    nuPage:"#FFFFFF", nuSide:"#FBF7EE", nuSideText:"#2E2410", nuSideMuted:"#6B5A36",
    nuSideLine:"#E6DCC6", nuSideActive:"#8B6A1F", nuSideMark:"#8B6A1F", nuLine:"#EFE6D2",
  },
};

export const NEW_UI_FONT = "'Source Sans 3', system-ui, -apple-system, 'Segoe UI', sans-serif";
const DISPLAY_FONT = "'Bricolage Grotesque', 'Source Sans 3', system-ui, sans-serif";
const MONO_FONT = "'IBM Plex Mono', ui-monospace, monospace";
export const SIDEBAR_WIDTH = 248;

// Fontes + regras de tela. No computador: barra lateral e abas do topo
// escondidas. No celular (até 899px): sem barra lateral, abas do topo voltam.
export function NewUiStyles() {
  return (
    <style>{`
@import url('https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,500;12..96,700&family=Source+Sans+3:wght@400;600;700&family=IBM+Plex+Mono:wght@400;500&display=swap');
.nu-root { margin-left: ${SIDEBAR_WIDTH}px; }
.nu-root .nu-tabs-row, .nu-root .nu-brand { display: none !important; }
.nu-sidebar button:focus-visible { outline: 2px solid currentColor; outline-offset: -2px; }
@media (max-width: 899px) {
  .nu-root { margin-left: 0; }
  .nu-sidebar { display: none !important; }
  .nu-root .nu-tabs-row { display: flex !important; }
  .nu-root .nu-brand { display: block !important; }
}
`}</style>
  );
}

export function NewSidebar({ theme, tabs, activeTab, onSelect, storeName, userName, roleLabel }) {
  const th = theme;
  return (
    <aside className="nu-sidebar" aria-label="Menu principal" style={{
      position:"fixed", left:0, top:0, bottom:0, width:SIDEBAR_WIDTH, zIndex:25,
      background:th.nuSide, color:th.nuSideText, display:"flex", flexDirection:"column",
      boxSizing:"border-box", borderRight:`1px solid ${th.nuSideLine}`, fontFamily:NEW_UI_FONT,
    }}>
      <div style={{ padding:"26px 20px 18px", borderBottom:`1px solid ${th.nuSideLine}` }}>
        <div style={{ fontFamily:MONO_FONT, fontSize:11, letterSpacing:1, color:th.nuSideMark }}>AR Flow</div>
        <div style={{ fontFamily:DISPLAY_FONT, fontSize:23, fontWeight:700, lineHeight:1.15, marginTop:6 }}>
          {storeName || "Todas as lojas"}
        </div>
      </div>

      <nav style={{ flex:1, overflowY:"auto", padding:"12px 10px" }}>
        {tabs.map(t => {
          const active = t.id === activeTab;
          return (
            <button key={t.id} onClick={() => onSelect(t.id)} aria-current={active ? "page" : undefined} style={{
              width:"100%", display:"block", textAlign:"left", border:"none", cursor:"pointer",
              padding:"10px 12px", marginBottom:2, borderRadius:4, fontFamily:NEW_UI_FONT,
              fontSize:14, fontWeight:active ? 700 : 500,
              background:active ? th.nuSideActive : "transparent",
              color:active ? "#FFFFFF" : th.nuSideText,
              opacity:active ? 1 : 0.86,
              boxShadow:active ? `inset 3px 0 0 ${th.nuSideMark}` : "none",
            }}>
              {t.label}
            </button>
          );
        })}
      </nav>

      <div style={{ padding:"16px 20px 22px", borderTop:`1px solid ${th.nuSideLine}` }}>
        <div style={{ fontSize:14, fontWeight:600 }}>{userName}</div>
        <div style={{ fontSize:12, color:th.nuSideMuted, marginTop:2 }}>{roleLabel}</div>
      </div>
    </aside>
  );
}
